import { useTranslation } from 'react-i18next';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import BrandingWatermarkOutlinedIcon from '@mui/icons-material/BrandingWatermarkOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import InterestsOutlinedIcon from '@mui/icons-material/InterestsOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CropFreeOutlinedIcon from '@mui/icons-material/CropFreeOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import MergeOutlinedIcon from '@mui/icons-material/MergeOutlined';

import { STUDIO_ACTIONS } from '../constants';
import { MEDIA_TYPES } from '../../../constants';

const usePredefineOptions = (mediaType = MEDIA_TYPES.IMAGE) => {
  const { t } = useTranslation('studio');

  if (mediaType === MEDIA_TYPES.VIDEO) {
    return {
      chooseAnOptionLabel: t('chooseAnOption'),
      options: [
        {
          groupLabel: null,
          options: [
            {
              label: t('freeTextEdit'),
              value: STUDIO_ACTIONS.FREE_TEXT_EDIT,
              Icon: EditNoteOutlinedIcon,
              description: t('freeTextEditDescription'),
              disabled: false,
            },
          ],
        },
        {
          groupLabel: t('createNew'),
          options: [
            {
              label: t('formats'),
              Icon: CategoryOutlinedIcon,
              value: STUDIO_ACTIONS.CREATE_FORMATS,
              description: t('createFormatsDescription'),
              disabled: false,
            },
          ],
        },
      ],
    };
  }

  return {
    chooseAnOptionLabel: t('chooseAnOption'),
    options: [
      {
        groupLabel: null,
        options: [
          {
            label: t('freeTextEdit'),
            value: STUDIO_ACTIONS.FREE_TEXT_EDIT,
            Icon: EditNoteOutlinedIcon,
            description: t('freeTextEditDescription'),
            disabled: false,
          },
        ],
      },
      {
        groupLabel: t('add'),
        options: [
          {
            label: t('logo'),
            Icon: BrandingWatermarkOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_LOGO,
            description: t('addLogoDescription'),
            disabled: false,
          },
          {
            label: t('text'),
            Icon: TextFieldsOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_TEXT,
            description: t('addTextDescription'),
            disabled: false,
          },
          {
            label: t('visualElementsFromText'),
            Icon: InterestsOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_TEXT,
            description: t('addVisualElementsDescription'),
            disabled: false,
          },
          {
            label: t('visualElementsFromImage'),
            Icon: ImageOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_VISUAL_ELEMENTS_FROM_IMAGE,
            description: t('UNDEFINED'),
            disabled: false,
          },
          {
            label: t('roomForText'),
            Icon: CropFreeOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_ROOM_FOR_TEXT,
            description: t('UNDEFINED'),
            disabled: false,
          },
          {
            label: t('realism'),
            Icon: PhotoCameraOutlinedIcon,
            value: STUDIO_ACTIONS.ADD_REALISM,
            description: t('UNDEFINED'),
            disabled: false,
          },
        ],
      },
      {
        groupLabel: t('change'),
        options: [
          {
            label: t('setting'),
            Icon: TuneOutlinedIcon,
            value: STUDIO_ACTIONS.CHANGE_SETTING,
            description: t('changeSettingDescription'),
            disabled: false,
          },
          {
            label: t('element'),
            Icon: WidgetsOutlinedIcon,
            value: STUDIO_ACTIONS.CHANGE_ELEMENT,
            description: t('changeElementDescription'),
            disabled: false,
          },
          {
            label: t('brandLook'),
            Icon: LooksOutlinedIcon,
            value: STUDIO_ACTIONS.CHANGE_BRAND_LOOK,
            description: t('UNDEFINED'),
            disabled: false,
          },
          {
            label: t('style'),
            Icon: PaletteOutlinedIcon,
            value: STUDIO_ACTIONS.CHANGE_STYLE,
            description: t('changeStyleDescription'),
            disabled: false,
          },
          {
            label: t('cutoutElement'),
            Icon: ContentCutOutlinedIcon,
            value: STUDIO_ACTIONS.CHANGE_CUTOUT_ELEMENT,
            description: t('UNDEFINED'),
            disabled: false,
          },
        ],
      },
      {
        groupLabel: t('createNew'),
        options: [
          {
            label: t('formats'),
            Icon: CategoryOutlinedIcon,
            value: STUDIO_ACTIONS.CREATE_FORMATS,
            description: t('createFormatsDescription'),
            disabled: false,
          },
          {
            label: t('angles'),
            Icon: SwapHorizOutlinedIcon,
            value: STUDIO_ACTIONS.CREATE_ANGLES,
            description: t('createAnglesDescription'),
            disabled: false,
          },
          {
            label: t('variants'),
            Icon: AutoAwesomeMotionOutlinedIcon,
            value: STUDIO_ACTIONS.CREATE_VARIANTS,
            description: t('createVariantsDescription'),
            disabled: false,
            actionId: STUDIO_ACTIONS.CREATE_VARIANTS,
          },
          {
            label: t('conceptRecreate'),
            Icon: AutoAwesomeOutlinedIcon,
            value: STUDIO_ACTIONS.CONCEPT_RECREATE,
            description: t('conceptRecreateDescription'),
            disabled: false,
          },
          {
            label: t('mergeImages'),
            Icon: MergeOutlinedIcon,
            value: STUDIO_ACTIONS.MERGE_IMAGES,
            description: t('UNDEFINED'),
            disabled: false,
          },
        ],
      },
      {
        groupLabel: t('animate'),
        options: [
          {
            label: t('createVideo'),
            Icon: VideoCameraBackOutlinedIcon,
            value: STUDIO_ACTIONS.CREATE_VIDEO,
            description: t('createVideoDescription'),
            disabled: false,
          },
        ],
      },
    ],
  };
};

export default usePredefineOptions;
